module.exports = __webpack_public_path__ + "img/layout-seven.c94d238a.svg";